export default __webpack_public_path__ + "static/media/dashboard.90e8ab98.png";